import * as types from './types';

// sync
export const setSpeakers = speakers => ({ type: types.SET_SPEAKERS, payload: speakers });
